import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { LucideDynamicIcon, LucideIconInput } from '@lucide/angular';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { UserRole } from '@app/core/models/user-role';
import { AuthService } from '@app/core/services/auth.service';

@Component({
  selector: 'app-navbar-button',
  imports: [RouterLink, RouterLinkActive, LucideDynamicIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'navbar-button.html',
  styleUrl: 'navbar-button.css',
})
export class NavbarButton {
  readonly #authService = inject(AuthService);

  readonly roles = input<UserRole[]>([]);
  readonly route = input<string>();
  readonly label = input.required<string>();
  readonly icon = input.required<LucideIconInput>();
  readonly exact = input(false);
  readonly action = output();

  readonly isVisible = computed(() => {
    const roles = this.roles();
    if (!roles.length) return true;
    return this.#authService.hasAnyRole(roles);
  });
}
